export default "__VITE_ASSET__CKqLMTmK__"